import { Component, OnInit, ChangeDetectorRef, ViewChild, Input, Output, EventEmitter, ElementRef } from '@angular/core';
import { Ng2ImgMaxService } from 'ng2-img-max';
import { SharedService } from '../../../shared/sharedServices/shared.service';
import { HecResponse } from '../../shared-interfaces/hecResponse';
import { HEC_CONSTANTS } from '../../../utilities/constants';
import { CommonHelper } from '../../../utilities/common.helper';
import { UploadDocumentsService } from './upload-documents.service';
import { UploadDocumentsService as DasPcdUploadDocumentsService } from '../../../views/pages/das/components/upload-documents/services/upload-documents.service';
import { NgForm } from '@angular/forms';
import { MatSnackBar } from '@angular/material';
import { LoaderService } from '../../sharedServices/loader.service';
import { decrypt } from '../../../utilities/utilityFunctions';
import { NameService } from '../../../views/pages/das/services/name.service';
import { NameService as DesNameService } from '../../../views/pages/des/services/name.service';
import { PopupModalService } from '../../../views/pages/des/services/popup-modal.service';
import { Router } from '@angular/router';
// import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'kt-upload-document',
  templateUrl: './upload-documents.component.html',
  styleUrls: ['./upload-documents.component.scss']
})
export class UploadDocumentsComponent implements OnInit {
  /** When true (DAS Documents tab only): same API, PDF-only, and max size as DAS Education Document List uploads. */
  @Input() useDasDocumentUploadPolicy = false;

  /** KB — aligned with `kt-upload-documents` (DAS) education / personal uploads. */
  private static readonly DAS_DOCUMENTS_TAB_MAX_SIZE_KB = 2048;

  public isCollapsed = true;
  public formViewType:any;
  @ViewChild('uploadDocumentsDetail',{static:false}) uploadDocumentsDetail: NgForm;
  @Input('dropdownValues')dropdownValues:any= {};
  @Input('applicationId')applicationId:number;
  @Input('documentCategory')documentCategory:any;
  @Input('profileId')profileId:any;
  @Input('isDES')isDES:boolean=false;
  public degreeDetailsDocumentList:any;
  @ViewChild('fileDropRef',{static:false}) fileDropRef: ElementRef;
  files: any[] = [];
  public eduDropdownLevel:any={qualificationLevel:[],programTitle:[]};
  private selectedFilePayload: any;
  private attachmentBase64: string;
  /** Binary file for multipart `api/das/app/docs/upload` when `useDasDocumentUploadPolicy` is set. */
  private pendingUploadFile: File | null = null;
  public isImageAlert:boolean = false;
  private fileExt;
  //: string = HEC_CONSTANTS.CONSTANT_VALUES.fileExt;
  private maxSize: number = HEC_CONSTANTS.CONSTANT_VALUES.maxSize;
  public loader: boolean = false;
  public fileUploader:boolean=false;
  public desUrl=HEC_CONSTANTS.DES_URLS;
  @Output() showOtherDocPop = new EventEmitter();
  @Output() uploadUpdatedData = new EventEmitter();
  constructor(private cdr: ChangeDetectorRef,private ng2ImgMax: Ng2ImgMaxService,private desNameService:DesNameService,
    public _snackBar: MatSnackBar,private loaderService:LoaderService,private nameService:NameService,
    private sharedService:SharedService, private uploadService:UploadDocumentsService,
    private dasPcdUploadService: DasPcdUploadDocumentsService,
    private popupService:PopupModalService,
    public router: Router) { }

  ngOnInit() {
    if (this.useDasDocumentUploadPolicy) {
      this.fileExt = HEC_CONSTANTS.CONSTANT_VALUES.desFileExt;
      this.maxSize = UploadDocumentsComponent.DAS_DOCUMENTS_TAB_MAX_SIZE_KB;
    } else {
      this.isDES ? this.fileExt = HEC_CONSTANTS.CONSTANT_VALUES.desFileExt : this.fileExt = HEC_CONSTANTS.CONSTANT_VALUES.fileExt;
    }
  }

  get filePickerAcceptAttr(): string {
    return this.useDasDocumentUploadPolicy ? '.pdf,.PDF' : '.png,.pdf,.PNG,.PDF';
  }

  onFileDropped($event) {
    this.prepareFilesList($event);
  }

  /**
   * handle file from browsing
   */
  fileBrowseHandler(files) {
    this.prepareFilesList(files);
  }

  /**
   * Delete file from files list
   * @param index (File index)
   */
  deleteFile(index: number) {
    this.files.splice(index, 1);
  }

  /**
   * Simulate the upload process
   */
  uploadFilesSimulator(index: number) {
    setTimeout(() => {
      if (index === this.files.length) {
        return;
      } else {
        const progressInterval = setInterval(() => {
          if (this.files[index].progress === 100) {
            clearInterval(progressInterval);
            this.uploadFilesSimulator(index + 1);
            this.fileUploader=false;
            this.cdr.detectChanges();
          } else {
            this.files[index].progress += 5;
          }
        }, 200);
      }
    }, 1000);
  }

  /**
   * Convert Files list to normal array list
   * @param files (Files List)
   */
  async prepareFilesList(e: Array<any>) {
    if (e.length > 1) {
      return false;
    }
    const image = e[0];
    let file = e[0];

    if (this.useDasDocumentUploadPolicy) {
      if (file.type && file.type !== 'application/pdf') {
        this._snackBar.open('Only PDF files are allowed.', '', {
          duration: 3500,
          panelClass: ['error-snackbar']
        });
        if (this.fileDropRef && this.fileDropRef.nativeElement) {
          this.fileDropRef.nativeElement.value = null;
        }
        this.cdr.detectChanges();
        return;
      }
    }

    if (this.isValidFile(file)) {
      this.pendingUploadFile = null;
      this.fileUploader = true;
      this.cdr.detectChanges();

      if (this.useDasDocumentUploadPolicy) {
        this.pendingUploadFile = file;
      } else if (file.type !== 'application/pdf') {
        this.ng2ImgMax.compressImage(image, 0.575).subscribe(
          async result => {
            await this.setAttachmentsPayload(result);
          },
          error => {
            console.log(error);
            this.fileUploader = false;
            this.cdr.detectChanges();
          }
        );
      } else {
        await this.setAttachmentsPayload(image);
      }

      for (const item of e) {
        item.progress = 0;
        this.files.push(item);
      }
      this.uploadFilesSimulator(0);
    } else {
      e = undefined;
      file = undefined;
      if (this.fileDropRef && this.fileDropRef.nativeElement) {
        this.fileDropRef.nativeElement.value = null;
      }
    }
  }

  private isValidFile(file) {
    if (this.useDasDocumentUploadPolicy) {
      return this.isValidFileDasDocumentsTab(file);
    }
    const extensions = (this.fileExt.split(',')).map(function (x) { return x.toLocaleLowerCase().trim(); }); // array of extensions
    const ext = file.name.toLowerCase().split('.').pop() || file.name; // file extension
    const fileSizeinKB = file.size / 1024;

    if (extensions.indexOf(ext) === -1) {
      this.isImageAlert = true;
      this._snackBar.open('Error in uploading ' + file.name + ' due to invalid file type.', '', {
        duration: 3500,
        panelClass: ['error-snackbar']
      });
      // this.toastr.warning('Error in uploading ' + file.name + ' due to invalid file type.');
      file=[];
      this.cdr.detectChanges();
      setTimeout(() => {
        this.isImageAlert = false;
        this.cdr.detectChanges();
      }, 3000);   
      // this.msgPopup('Error', 'Error in uploading ' + file.name + ' due to invalid file type.','alert-error-popup')
      return false;
    } else if (!file.name.match()) {
      this.isImageAlert = true;
      file=[];
      this._snackBar.open('Invalid File Name', '', {
        duration: 3500,
        panelClass: ['error-snackbar']
      });
      // this.toastr.warning('Invalid File Name');
      this.cdr.detectChanges();
      setTimeout(() => {
        this.isImageAlert = false;
        this.cdr.detectChanges();
      }, 3000);   
      // this.msgPopup('Error', 'Invalid File Name','alert-error-popup')
      return false;
    } 
    else if (fileSizeinKB > this.maxSize) {
      file=[];
      this.isImageAlert = true
      this._snackBar.open(file.name + ' ( ' + (fileSizeinKB / 1024).toFixed(2) + 'MB )' + ' exceeds file size limit of ' + (this.maxSize / 1024).toFixed(2) + 'MB.', '', {
        duration: 3500,
        panelClass: ['error-snackbar']
      });
      // this.toastr.warning(file.name + ' ( ' + (fileSizeinKB / 1024).toFixed(2) + 'MB )' + ' exceeds file size limit of ' + (this.maxSize / 1024).toFixed(2) + 'MB.');
      this.cdr.detectChanges();
      setTimeout(() => {
        this.isImageAlert = false;
        this.cdr.detectChanges();
      }, 3000);   
      // this.msgPopup('Error', file.name + ' ( ' + (fileSizeinKB / 1024).toFixed(2) + 'MB )' + ' exceeds file size limit of ' + (this.maxSize / 1024).toFixed(2) + 'MB.','alert-error-popup')
      return false;
    }
    return true;
  }

  /** Same rules as DAS `kt-upload-documents` `isValidFile` (PDF-only extension list, name pattern, max 2 MB). */
  private isValidFileDasDocumentsTab(file: File): boolean {
    const extensions = (this.fileExt.split(',')).map(function (x) { return x.toLocaleLowerCase().trim(); });
    const ext = file.name.toLowerCase().split('.').pop() || file.name;
    const fileSizeinKB = file.size / 1024;

    if (extensions.indexOf(ext) === -1) {
      this.isImageAlert = true;
      this._snackBar.open('Error in uploading ' + file.name + ' due to invalid file type.', '', {
        duration: 3500,
        panelClass: ['error-snackbar']
      });
      this.cdr.detectChanges();
      setTimeout(() => {
        this.isImageAlert = false;
        this.cdr.detectChanges();
      }, 3000);
      return false;
    }
    if (!file.name.match(HEC_CONSTANTS.CONSTANT_VALUES.fileAllowedFormat)) {
      this.isImageAlert = true;
      this._snackBar.open('Invalid File Name', '', {
        duration: 3500,
        panelClass: ['error-snackbar']
      });
      this.cdr.detectChanges();
      setTimeout(() => {
        this.isImageAlert = false;
        this.cdr.detectChanges();
      }, 3000);
      return false;
    }
    if (fileSizeinKB > this.maxSize) {
      this.isImageAlert = true;
      this._snackBar.open(
        file.name +
          ' ( ' +
          (fileSizeinKB / 1024).toFixed(2) +
          ' MB ) exceeds file size limit of ' +
          (this.maxSize / 1024).toFixed(2) +
          ' MB.',
        '',
        {
          duration: 3500,
          panelClass: ['error-snackbar']
        }
      );
      this.cdr.detectChanges();
      setTimeout(() => {
        this.isImageAlert = false;
        this.cdr.detectChanges();
      }, 3000);
      return false;
    }
    return true;
  }

  private async setAttachmentsPayload(file) {
    this.attachmentBase64 = (await this.convertFileToBase64(file)).toString();
  }

  private uploadAttachment() {
    if (this.useDasDocumentUploadPolicy) {
      this.uploadViaDasPcdApi();
      return;
    }
    this.loader=true;
    this.loaderService.setValue(this.loader)
    this.selectedFilePayload = '';
    this.selectedFilePayload = this.attachmentBase64;
    let found;
    if(!this.isDES){
    found = this.dropdownValues.documentType.find(element => {
      return element.value == this.uploadDocumentsDetail.value.documentType;
    });
  }
    let acronym;
    if(this.isDES && this.router.url == this.desUrl.LOCAL_DES){
      acronym = 'DES'
    }else if(this.isDES && this.router.url == this.desUrl.FOREIGN_DES){
      acronym = 'DESF'
    }else{
      acronym = 'DAS'

    }
    let payload = {
      data: {
          applicationId: this.applicationId,
          addedBy: this.nameService.getCNIC() ? this.nameService.getCNIC() : this.desNameService.getCNIC(),
          content: this.selectedFilePayload,
          processAcronym: acronym,
          category: this.documentCategory,
          title: !this.isDES ? found.label.toString() : this.uploadDocumentsDetail.value.documentType ,
          description: !this.isDES ? found.label.toString() : this.uploadDocumentsDetail.value.documentType ,
          comments: this.uploadDocumentsDetail.value.comments
      }
    }
    this.uploadService.uploadDocument(payload)
      .subscribe(
        (res:HecResponse) => {
          if (res.statusCode == HEC_CONSTANTS.HTTP_RESPONSE.OK) {
          this.loader=false;
          this.loaderService.setValue(this.loader)
          this.cdr.detectChanges();
            this.uploadUpdatedData.emit({reqPayload:payload,resPayload:res.data,
              documentCategory:this.documentCategory,selectedOption:found})
            this.cdr.detectChanges();
          }
          else{
            this.loader=false;
            this.loaderService.setValue(this.loader)
            this.sharedService.openPopupDialog('Error',HEC_CONSTANTS.MESSGAES_LIST.SOMETHING_LATER_ERROR,HEC_CONSTANTS.ERROR_TYPES.error)
            this._snackBar.open(HEC_CONSTANTS.MESSGAES_LIST.SOMETHING_LATER_ERROR, '',  {
              duration: 3500,
              panelClass: ['error-snackbar']
            });
            // this.ale
          }
        },
        (err) => {
          this.loader=false;
          this.loaderService.setValue(this.loader)
          this.sharedService.openPopupDialog('Error',HEC_CONSTANTS.MESSGAES_LIST.SOMETHING_LATER_ERROR,HEC_CONSTANTS.ERROR_TYPES.error)
          this._snackBar.open(HEC_CONSTANTS.MESSGAES_LIST.SOMETHING_LATER_ERROR, '',  {
            duration: 3500,
            panelClass: ['error-snackbar']
          });
          this.cdr.detectChanges();
          console.log(err)
        }
      )
  }

  /** Multipart upload to `api/das/app/docs/upload` (same as DAS Education list). */
  private uploadViaDasPcdApi(): void {
    const filePart = this.pendingUploadFile;
    if (!filePart) {
      this._snackBar.open('No file selected.', '', {
        duration: 3500,
        panelClass: ['error-snackbar']
      });
      this.cdr.detectChanges();
      return;
    }

    const docName =
      this.uploadDocumentsDetail &&
      this.uploadDocumentsDetail.value &&
      this.uploadDocumentsDetail.value.documentType != null
        ? String(this.uploadDocumentsDetail.value.documentType).trim()
        : '';
    if (!docName) {
      return;
    }

    const uploadTitle = docName.replace(/\s+/g, '-').replace(/\//g, 'OR');
    const payloadData: any = {
      applicationId: this.applicationId,
      addedBy: this.nameService.getCNIC(),
      file: filePart,
      processAcronym: 'DAS',
      category: this.documentCategory,
      title: uploadTitle,
      description: docName,
    };

    const commentsVal =
      this.uploadDocumentsDetail &&
      this.uploadDocumentsDetail.value &&
      this.uploadDocumentsDetail.value.comments;
    if (commentsVal != null && String(commentsVal).trim() !== '') {
      payloadData.comments = commentsVal;
    }
    payloadData.degreeId = 111;

    const reqPayloadCompat = {
      data: {
        title: uploadTitle,
        category: this.documentCategory,
        applicationId: this.applicationId,
      },
    };

    const payload = { data: payloadData };

    this.loader = true;
    this.loaderService.setValue(this.loader);
    this.dasPcdUploadService.uploadDocument(payload).subscribe(
      (res: HecResponse) => {
        this.loader = false;
        this.loaderService.setValue(this.loader);
        if (res.statusCode === HEC_CONSTANTS.HTTP_RESPONSE.OK) {
          this.pendingUploadFile = null;
          this.files = [];
          if (this.fileDropRef && this.fileDropRef.nativeElement) {
            this.fileDropRef.nativeElement.value = null;
          }
          this.fileUploader = false;
          this._snackBar.open(HEC_CONSTANTS.MESSGAES_LIST.UPLOAD_SUCCESS, '', {
            duration: 3500,
            panelClass: ['success-snackbar'],
          });
          this.uploadUpdatedData.emit({
            reqPayload: reqPayloadCompat,
            resPayload: res.data,
            documentCategory: this.documentCategory,
            selectedOption: undefined,
          });
          this.cdr.detectChanges();
        } else {
          this.sharedService.openPopupDialog(
            'Error',
            HEC_CONSTANTS.MESSGAES_LIST.SOMETHING_LATER_ERROR,
            HEC_CONSTANTS.ERROR_TYPES.error
          );
          this._snackBar.open(HEC_CONSTANTS.MESSGAES_LIST.SOMETHING_LATER_ERROR, '', {
            duration: 3500,
            panelClass: ['error-snackbar'],
          });
          this.cdr.detectChanges();
        }
      },
      err => {
        this.loader = false;
        this.loaderService.setValue(this.loader);
        this.sharedService.openPopupDialog(
          'Error',
          HEC_CONSTANTS.MESSGAES_LIST.SOMETHING_LATER_ERROR,
          HEC_CONSTANTS.ERROR_TYPES.error
        );
        this._snackBar.open(HEC_CONSTANTS.MESSGAES_LIST.SOMETHING_LATER_ERROR, '', {
          duration: 3500,
          panelClass: ['error-snackbar'],
        });
        this.cdr.detectChanges();
        console.log(err);
      }
    );
  }

  private convertFileToBase64(file): any {
    return new Promise((resolve, reject) => {
      CommonHelper.convertFileToBase64(file).then((result) => {
        resolve(result);
      })
        .catch(function (error) {
          console.log(error)
          resolve(null);
        })
    })
  }

  formatBytes(bytes, decimals) {
    if (bytes === 0) {
      return '0 Bytes';
    }
    const k = 1024;
    const dm = decimals <= 0 ? 0 : decimals || 2;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
  }

  public uploadDocuments(){
    this.markFormsTouched(this.uploadDocumentsDetail)
    const attachmentsReady = this.useDasDocumentUploadPolicy
      ? this.pendingUploadFile != null
      : this.attachmentBase64 != undefined;
    if (this.validate(this.uploadDocumentsDetail) && attachmentsReady) {
      this.uploadAttachment();
    }
  }

    
  public markFormsTouched(form): void {
    CommonHelper.markFormGroupTouched(form);
  }

  public validate(f): boolean {
    if (f.status === 'VALID') {
      return true;
    }
  }

  public getDocumentSelection(event){
    for(let i=0; i < this.degreeDetailsDocumentList.length;i++){
      for(let j=0; j < this.degreeDetailsDocumentList[i].docList.length;j++){
        if(this.degreeDetailsDocumentList[i].docList[j].documentTypeCodeId == event) {
          this.eduDropdownLevel.qualificationLevel.push({label: this.degreeDetailsDocumentList[i].degreeName,value:i})
          this.eduDropdownLevel.programTitle.push({label: this.degreeDetailsDocumentList[i].subjectName,value:i})
          // this.dropdownValues.qualificationLevel[i].label=this.degreeDetailsDocumentList[i].degreeName
          // this.dropdownValues.qualificationLevel[i].valuei
        }         
    }      
    }
    this.eduDropdownLevel.qualificationLevel= this.removeDup(this.eduDropdownLevel.qualificationLevel)
    this.eduDropdownLevel.programTitle= this.removeDup(this.eduDropdownLevel.programTitle)
  }

  public cancelUpload(){
    this.pendingUploadFile = null;
    this.uploadUpdatedData.emit('cancel')
  }

  public removeDup(array){
    const uniqueArray = array.filter((thing, index) => {
      const _thing = JSON.stringify(thing);
      return index ===  array.findIndex(obj => {
        return JSON.stringify(obj) === _thing;
      });
    });
    return uniqueArray;
  }

  public getSelectedDocument(value){
    if(value == 14){
      this.showOtherDocPop.emit(true);
    }
  }

}
